import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import type { TaskListModel } from '@domain-group/realhub-backend-api-types'

import useTaskListSection from '@hooks/useTaskListSection'
import useTaskListSections from '@hooks/useTaskListSections'

import TaskListSection from './TaskListSection'

interface TaskListSectionsProps {
  taskList: TaskListModel,
}

const TaskListSections = (props: TaskListSectionsProps) => {
  const { taskList } = props

  const taskListSectionPayload = useTaskListSection({
    debtor_id: taskList.debtor_id,
    debtor_type: taskList.debtor_type,
    task_list_id: taskList.id,
  })

  const { callbacks: { createOrEditTaskListSection } } = taskListSectionPayload

  const taskListSectionsPayload = useTaskListSections({
    filters: {
      task_list_id: taskList.id,
    },
  })

  const { filteredTaskListSections, hasFilteredTaskListSections, loading } = taskListSectionsPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        // @ts-expect-error TS2322
        <DashboardModule.Link href={`#/tasks?task_list_id=${taskList.id}`}>
          View All Tasks
        </DashboardModule.Link>
      )}
      loading={loading}
      title="Project Groups"
    >
      <Box flexDirection="column">
        {filteredTaskListSections.map(taskListSection => (
          <TaskListSection key={taskListSection.id} taskListSection={taskListSection} />
        ))}
      </Box>

      <DashboardModule.Footer
        boxProps={{
          borderTop: loading || !hasFilteredTaskListSections ? 'none' : '1px solid',
        }}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditTaskListSection()}
          marginLeft="auto"
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Group
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default TaskListSections
